module.exports = __webpack_public_path__ + "img/ShotaArveladze-Seedorf.b7896cd5.webp";